import { useQuery } from "@tanstack/react-query";
import api from "../utils/api";

export const fetchGetAgendaWithIndividualAssignment = async (studyId) => {
  // 쿼리 파라미터가 추가된 URL로 API를 호출합니다.

  return await api.get(`/assignment/${studyId}`);
};

export const useGetAgendaWithIndividualAssignmentQuery = (studyId) => {
  return useQuery({
    queryKey: ["assignments", studyId],
    enabled: !!studyId,
    queryFn: () => fetchGetAgendaWithIndividualAssignment(studyId),
    select: (data) => {
      return data.data.data;
    },
    keepPreviousData: true,
  });
};
